var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLemonway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#57ED7D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.9,306.8h10.8v30.1h18.8v9.7h-29.6V306.8 M249.7,306.8H281v9.4h-20.7v6h18.7v8.7h-18.7v6.3h21v9.4h-31.6 V306.8 M299,306.8h11.4l9.3,15.4l9.2-15.4h11.4v39.8h-10.7v-22.8l-10,15.5h-0.3l-9.9-15.4v22.7H299V306.8 M388.1,326.8L388.1,326.8 c0-5.8-4.1-10.8-10-10.8c-5.9,0-9.8,4.9-9.8,10.6v0.1c0,5.7,4.1,10.8,10,10.8C384.1,337.4,388.1,332.6,388.1,326.8z M357.1,326.8 L357.1,326.8c0-11.5,9-20.8,21-20.8c12,0,20.9,9.2,20.9,20.6v0.1c0,11.4-9,20.6-21,20.6C366,347.4,357.1,338.2,357.1,326.8z  M415.9,306.8H426l16,21v-21h10.7v39.8h-9.5l-16.6-21.8v21.8h-10.7V306.8 M467.8,306.8h11.4l6.8,23l7.5-23.2h9.3l7.5,23.2l6.8-23 h11.2l-13,40h-9.5L498,324l-7.8,22.9h-9.4L467.8,306.8 M562.8,330.9l-4.3-11.3l-4.4,11.3H562.8z M553.4,306.5h10.4l16.6,40h-11.6 l-2.8-7.1h-15l-2.8,7.1h-11.4L553.4,306.5z M601.4,331.7l-14.8-24.9h12.3l8,14.5l8-14.5H627l-14.8,24.7v15.1h-10.8V331.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    className: "st1",
    d: "M142.6,327.7c-0.2,0.6-0.5,1.2-0.7,1.8c-1.2,2.5-1.6,5.1-1.7,7.6c0,0.5,0,1.1,0,1.6 c0.4,2.2,0.4,4.8-0.1,7.2c-0.1,0.6-0.3,1.2-0.5,1.7c-1.1,4.3-5.2,7.3-9.4,6.6c7.8-6.2,5.6-17.5,5.6-17.5c-0.5,10.4-7.2,16.2-9.5,18 c0,0-0.1-0.1-0.1-0.1c-10.4-27.7-43.6-31.2-43.6-31.2c28.4,10.5,37.8,27.6,40.7,36.1c-0.1,0.1-0.1,0.1-0.2,0.2 c-4.9,6-10.8,9.8-18.8,10.2c-5.6,0.2-10.9-0.3-16.1-1.8c-1.3-0.4-2.7-0.9-4-1.6c-17-7.8-31.2-29.9-27.5-77.2c0,0,2.5,2.7,6.4,6.3 c1.3,1.2,2.8,2.4,4.3,3.7c5.8,5.5,12.5,9.1,19.8,11.6c1.5,0.5,3,0.9,4.4,1.4c6.6,0.9,13.7,3.2,19.8,6.6c1.6,0.9,3,1.8,4.4,2.9 c4.6,2.9,8.1,7.1,10.2,11.9c3.3-3.5,8.9-6.8,17.9-8.8C143.9,325,143.3,326.1,142.6,327.7 M97,254.6c-38.6,0-70,32-70,71.4 s31.3,71.4,70,71.4s70-32,70-71.4S135.6,254.6,97,254.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLemonway);
export default __webpack_public_path__ + "static/media/logo_lemonway.5b807b43935dcfcfc29de9dbcd719e13.svg";
export { ForwardRef as ReactComponent };